module.exports = __webpack_public_path__ + "static/media/DSC_0431.f8640b8d.jpg";